import React from 'react';
import type { DocNode as ADF } from '@atlaskit/adf-schema';
import TextIcon from '@atlaskit/icon/core/text';
import { DESCRIPTION_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { DescriptionFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import DescriptionField from '../../../ui/fields/description-field/index.tsx';
import type { FieldTypeConfig, ProvidedFieldProps } from '../types.tsx';
import { descriptionFieldWriter } from '../writers/index.tsx';

const DescriptionFieldTypeComponent = (props: ProvidedFieldProps) => (
	<DescriptionField
		{...props}
		defaultValue={undefined}
		fieldWrapperElement={null}
		mediaUploadContext={props.mediaUploadContexts.uploadContext}
	/>
);

export const DescriptionFieldTypeConfig: FieldTypeConfig<ADF> = {
	icon: TextIcon,
	type: DESCRIPTION_TYPE,
	Component: DescriptionFieldTypeComponent,
	placeholder: <DescriptionFieldPlaceholder />,
	writer: descriptionFieldWriter,
};
